import { consola } from 'consola'
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const usePaymentStore = defineStore('payment', () => {
  const confirmationToken = ref<string | null>(null)
  const confirmationUrl = ref<string | null>(null)
  const orderId = ref<number | null>(null)
  const amount = ref<number | null>(null)
  const status = ref<'pending' | 'succeeded' | 'failed' | null>(null)
  const error = ref<string | null>(null)
  const order = ref<any | null>(null)   // Сохраняем весь заказ

  // Actions
  function setConfirmationToken(token: string) {
    consola.debug('🔧 PaymentStore.setConfirmationToken called with:', token);
    // Handle both URL and token formats
    confirmationToken.value = token
    consola.debug('🔧 PaymentStore.setConfirmationToken result:', confirmationToken.value);
  }
  function setConfirmationUrl(token: string) {
    // Handle both URL and token formats
    confirmationUrl.value = token
  }

  function setOrderId(id: number) {
    orderId.value = id
  }

  function setStatus(val: 'pending' | 'succeeded' | 'failed' | null) {
    status.value = val
  }

  function setError(val: string | null) {
    error.value = val
  }

  function setAmount(val: number) {
    amount.value = val
  }

  function setOrder(val: any) {
    consola.debug('📦 PaymentStore.setOrder called with:', val);
    consola.debug('📦 Previous order value:', order.value);
    
    // Проверяем, если данные пришли в формате {success: true, order: {...}}
    let orderData = val
    if (val && val.success && val.order) {
      consola.debug('📦 [setOrder] Extracting order from API response structure')
      orderData = val.order
    }
    
    // Принудительно заменяем весь объект для гарантии реактивности
    order.value = orderData ? JSON.parse(JSON.stringify(orderData)) : null
    orderId.value = orderData?.id ? Number(orderData.id) : null
    
    // API возвращает total_amount, не totalAmount
    amount.value = orderData?.total_amount ? Number(orderData.total_amount) : null
    
    consola.debug('📦 PaymentStore.setOrder result:', {
      orderId: orderId.value,
      amount: amount.value,
      orderSaved: !!order.value,
      itemsCount: order.value?.items?.length || 0,
      status: order.value?.status,
      payment_status: order.value?.payment_status,
    });
    
    // Принудительно логируем что сохранилось в store
    consola.debug('📦 Final order in store:', order.value);
  }

  function updateOrderPaymentStatus(newStatus: string) {
    if (order.value) {
      order.value.payment_status = newStatus
    }
  }

  function updateOrderField(field: string, value: any) {
    if (order.value) {
      order.value[field] = value
    }
  }

  function resetPayment() {
    confirmationToken.value = null
    confirmationUrl.value = null
    orderId.value = null
    amount.value = null
    status.value = null
    error.value = null
    order.value = null
  }

  // Getters
  const isPaymentPending = computed(() => status.value === 'pending')
  const isPaymentSuccess = computed(() => status.value === 'succeeded')
  const isPaymentFailed = computed(() => status.value === 'failed')

  return {
    // state
    confirmationToken,
    confirmationUrl,
    orderId,
    amount,
    status,
    error,
    order,
    // actions
    setConfirmationToken,
    setConfirmationUrl,
    setOrderId,
    setStatus,
    setError,
    setAmount,
    setOrder,
    updateOrderPaymentStatus,
    updateOrderField,
    resetPayment,
    // getters
    isPaymentPending,
    isPaymentSuccess,
    isPaymentFailed,
  }
})
